import PosthogService from '~/services/posthog/PosthogService';

export interface IShiftRequestAutoconfirmExperimentExposedPayload {
  flagKey: string;
  variant: string;
}

/**
 * Fires once per shift request, only for payment-eligible offices, when the Auto-Confirm
 * section is reached. Used as the experiment's custom exposure event so the control group
 * is not diluted by offices that were never eligible for the default-on treatment — this is
 * what keeps eligibility a qualifier for exposure and avoids false negatives. Carries the
 * PostHog experiment attribution properties so the variant can be resolved downstream.
 * Event: dental_portal:shift_request:autoconfirm_experiment_exposed
 */
export function fireShiftRequestAutoconfirmExperimentExposed(
  payload: IShiftRequestAutoconfirmExperimentExposedPayload,
): void {
  PosthogService.getInstance().track(
    'dental_portal:shift_request:autoconfirm_experiment_exposed',
    {
      $feature_flag: payload.flagKey,
      $feature_flag_response: payload.variant,
    },
  );
}
